import React from "react";
import { USER, folderLabel, inProject } from "../../utils/shell";
import { BranchGlyph, CheckGlyph, CrossGlyph, FolderGlyph, GitHubGlyph } from "../promptGlyphs";

// The terminal panel's tabs as Sylvester's Zed shows them (titles cut short where Zed cut them):
// the dev server, which only shows what it printed, and bash, where the same small shell as in
// Ghostty runs (hooks/useShell.js), starting in the project.

// Sylvester's oh-my-posh prompt, as in Ghostty: his name, the folder, the branch in the project,
// and whether the last command worked. Zed's font has none of the icons (it shows boxes), so
// they're drawn as the prompt means them.
export const Prompt = ({ cwd, status }) => {
  const git = inProject(cwd);
  return (
    <span className="zd-prompt">
      <span className="zd-seg zd-seg--user">{` ${USER} `}</span>
      <span className={`zd-seg zd-seg--path ${git ? "is-before-git" : ""}`}>
        {" "}
        <span className="zd-glyph zd-glyph--folder">
          <FolderGlyph />
        </span>{" "}
        <span className="zd-seg-link">{folderLabel(cwd)}</span>{" "}
      </span>
      {git && (
        <span className="zd-seg zd-seg--git">
          {" "}
          <span className="zd-glyph zd-glyph--github">
            <GitHubGlyph />
          </span>{" "}
          <span className="zd-glyph zd-glyph--branch">
            <BranchGlyph />
          </span>
          {"master ≡ "}
        </span>
      )}
      <span className={`zd-seg zd-seg--status ${status ? "is-failed" : ""}`}>
        {" "}
        <span className={`zd-glyph ${status ? "zd-glyph--cross" : "zd-glyph--check"}`}>
          {status ? <CrossGlyph /> : <CheckGlyph />}
        </span>{" "}
      </span>
    </span>
  );
};

// What `npm start` prints once Create React App is serving (minus the LAN address).
export const DevServer = () => (
  <>
    <p className="zd-t-green">Compiled successfully!</p>
    <p>
      You can now view <b>federation-layout</b> in the browser.
    </p>
    <p>
      {"  "}
      <b>Local:</b>
      {"            "}http://localhost:<b>3000</b>
    </p>
    <p>
      Note that the development build is not optimized.
      {"\n"}To create a production build, use <span className="zd-t-cyan">npm run build</span>.
    </p>
    <p>
      webpack compiled <span className="zd-t-green">successfully</span>
    </p>
  </>
);

export const TERMINALS = {
  node: "federation-layout — node SHELL=/opt/homebrew/…",
  bash: "federation-layout — bash",
};
